import { render } from "./matching-card-compact-wrapper.vue?vue&type=template&id=00c3b50c&scoped=true&ts=true"
import script from "./matching-card-compact-wrapper.vue?vue&type=script&lang=ts"
export * from "./matching-card-compact-wrapper.vue?vue&type=script&lang=ts"

import "./matching-card-compact-wrapper.vue?vue&type=style&index=0&id=00c3b50c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00c3b50c"]])

export default __exports__